var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"idKey":"AccountId","labelKey":"AccountName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }